import { Button, Modal, ModalContent } from '@restworld/ui-ds-base';
import { getAssetSrc } from '@restworld/utils-common';
import Image from 'next/image';
import { ModalHeader, ModalSubHeader } from './common';
import { useDeleteAccountForm } from '../hooks/use-delete-account-form';
import { FlexCol } from './header';
import { useTranslation } from 'next-i18next';

export const DeleteAccountModal = () => {
  const { open, onClose, onOpen, onSubmit, loading } = useDeleteAccountForm();
  const { t } = useTranslation('user-settings');
  const { t: commonT } = useTranslation('common');
  const footer = (
    <FlexCol className="gap-4 w-full">
      <Button fullwidth={true} variant="secondary-danger" onClick={onSubmit} loading={loading}>
        {t('delete_account_button_text')}
      </Button>
      <Button fullwidth={true} variant="secondary-neutral" onClick={onClose}>
        {commonT('cancel')}
      </Button>
    </FlexCol>
  );
  const header = t('delete_account_modal_header');
  return (
    <>
      {/* master used a `danger-ghost` red text-link here (no equivalent variant on ui-ds-base);
          secondary-danger provides the red text, !bg-transparent strips the pink fill → compact red link. */}
      <Button variant="secondary-danger" className="!bg-transparent self-start !px-0 !h-auto" onClick={onOpen}>
        {t('delete_account_modal_button_text')}
      </Button>
      <Modal open={open} onOpenChange={(v) => !v && onClose()}>
        <ModalContent variant="center" title="" className="lg:min-w-[24rem] lg:max-w-[24rem]" footer={footer}>
          <FlexCol className="items-center">
            <Image src={getAssetSrc('/utils-assets/warning.svg')} width={64} height={64} alt={header} />
            <div className="flex flex-col items-center justify-start gap-2 mb-6 mt-2">
              <ModalHeader>{header}</ModalHeader>
              <ModalSubHeader>{t('delete_account_modal_subheader')}</ModalSubHeader>
            </div>
          </FlexCol>
        </ModalContent>
      </Modal>
    </>
  );
};
